import { Page } from '@/core/architecture'

import { MyTradeTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * MyTrade Page
 * Implemented as a practical sample.
 */
export const MyTrade: Page = () => {
  const { state, actions } = useViewModel()

  return <MyTradeTemplate state={state} {...actions} />
}
